module.exports = __webpack_public_path__ + "img/4.ee28a69b.jpg";